import script from "./inventoryInfoControlMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./inventoryInfoControlMenu.vue?vue&type=script&setup=true&lang=ts"

import "./inventoryInfoControlMenu.vue?vue&type=style&index=0&id=a3df8cd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3df8cd4"]])

export default __exports__